// src/components/FormSections/FormSectionAcademico.js

import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Row } from "reactstrap"
import Documentacion from "../Common/Documentacion"

// #region selectors
import {
  useCampusVirtualIdCampus,
  useCampusVirtualOptionsListaCampus,
  useCampusVirtualOptionsListaProgramasAcademicos,
  useCampusVirtualOptionsListaPlanesEstudio,
  useCampusVirtualOptionsListaTurnos,
  useCampusVirtualOptionsListaTrayectorias,
  useCampusVirtualOptionsListaStatus,
} from "store/selectors"
// #endregion

// #region actions
import {
  getCampusVirtualCampus,
  getCampusVirtualCarreras,
  getCampusVirtualPlanes,
  getCampusVirtualTurnos,
  getCampusVirtualTrayectorias,
  getCampusVirtualStatus,
} from "../../store/actions"
// #endregion

const FormSectionDocumentos = ({
  formik,
  handleUpperCaseChange,
  handleLowerCaseChange,
  resetForm,
}) => {
  //
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region const-selectors

  const idCampusCurrent = useCampusVirtualIdCampus()
  const optionsCampus = useCampusVirtualOptionsListaCampus()
  const optionsProgramasAcademicos =
    useCampusVirtualOptionsListaProgramasAcademicos()
  const optionsPlanesEstudio = useCampusVirtualOptionsListaPlanesEstudio()
  const optionsTurnos = useCampusVirtualOptionsListaTurnos()
  const optionsTrayectorias = useCampusVirtualOptionsListaTrayectorias()
  const optionsStatus = useCampusVirtualOptionsListaStatus()
  // #endregion

  // #region Internal States
  const [id_Campus_Alumno_Current, set_id_Campus_Alumno_Current] = useState(-1)
  const [id_Plan_Alumno_Current, set_id_Plan_Alumno_Current] = useState(-1)
  // #endregion

  // #region useEffects
  //
  //idCampusCurrent

  // #endregion

  return (
    <>
      {/* Sección de Documentos */}
      <h5 className="mb-4">Documentos</h5>
      <Row>
        <Documentacion
          oAlumno={{ id_Alumno: -1, id_Nivel_Educativo: 4 }}
          oPersona={{ id_Persona: -1, docs: [] }}
          formik={formik}
          altaAlumno={true}
        />
      </Row>
    </>
  )
}

export default FormSectionDocumentos
